import { fromJS } from 'immutable'
import {
  PUBLIC_HOLIDAY_EDIT_REQUEST,
  PUBLIC_HOLIDAY_EDIT_SUCCESS,
  PUBLIC_HOLIDAY_EDIT_FAILURE,
  PUBLIC_HOLIDAY_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PUBLIC_HOLIDAY_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case PUBLIC_HOLIDAY_EDIT_SUCCESS:
      return state
        .set('updatedHoliday', fromJS(action.payload.updatedHoliday))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case PUBLIC_HOLIDAY_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('updatedHoliday', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case PUBLIC_HOLIDAY_EDIT_RESET:
      return state
        .delete('updatedHoliday')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/public-holiday/public-holiday-edit-reducer.js